module.exports = __webpack_public_path__ + "img/art-slide-6-xl.8e5a38b.webp";